import {Component, Inject} from '@angular/core';
import {LayerListItem, TrvNgMapService} from "@trafikverket/trv-ng-map";
import {NvdbNavigationService} from "@app/service/nvdb-navigation.service";
import { LanguageService } from '@app/service/language.service';

@Component({
    selector: 'app-tecken-forklaring-tab',
    imports: [],
    templateUrl: './tecken-forklaring-tab.component.html',
    styleUrl: './tecken-forklaring-tab.component.scss'
})
export class TeckenForklaringTabComponent {

    constructor(
        @Inject(TrvNgMapService) public trvMapService: TrvNgMapService,
        public lang: LanguageService
    ) {
    }

    public getLegendGraphics(layer: LayerListItem) {
        if (layer.legendGraphics) {
            return layer.legendGraphics;
        }
        return "";
    }

    public hasNoVisibleLabels() {
        const trvMap = this.trvMapService.trvMap;
        if(!trvMap) return true;
        if(trvMap.trvLayer.getVisibleWmsLayer().length === 0) return true;
        for (let layer of trvMap.trvLayer.getVisibleWmsLayer()) {
            if (layer.legendGraphics && trvMap.trvLayer.getLayerData(layer, "hideLabel") != true) {
                return false;
            }
        }
        return true;
    }

}
